import React from "react"
import "../styles/BottomBar.css"
class BottomBar extends React.Component {
	render() {
		return (
			<div className="bottomBar">
				<p>This site was made using React and CSS. </p>
			</div>
		)
	}
}

export default BottomBar
